import 'angular-drag-and-drop-lists/angular-drag-and-drop-lists';

export default angular.module('ui.cian.angular-drag-and-drop-lists.adapter', ['dndLists'])
	.name;
